import { initializeApp } from 'firebase/app'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { firebaseConfig } from './settings'
import { FIREBASE_TENANT_ID } from './settings'

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

// Set the tenant ID
// Note: This is the key line that sets the tenant ID for all Firebase Auth operations
auth.tenantId = FIREBASE_TENANT_ID ?? null

// Enhanced authentication function that properly validates tokens
const signInWithToken = async (token: string) => {
  try {
    console.log(`Attempting to sign in with token, using tenant ID: ${FIREBASE_TENANT_ID}`)

    // Attempt to sign in with the custom token
    return await signInWithCustomToken(auth, token)
  } catch (error: any) {
    console.error('Firebase auth error:', error.code, error.message)

    // Handle specific Firebase auth errors
    if (error.code === 'auth/invalid-custom-token') {
      throw new Error('Invalid authentication token format')
    } else if (error.code === 'auth/custom-token-mismatch') {
      throw new Error('Token was not issued for this application')
    } else if (error.code === 'auth/tenant-id-mismatch') {
      throw new Error(`Authentication error: The tenant ID (${FIREBASE_TENANT_ID}) doesn't match the one in the token.`)
    } else {
      // For other errors, throw a generic message to avoid exposing sensitive details
      throw new Error('Authentication failed. Please try again.')
    }
  }
}

export { auth, signInWithToken }
